import { render, staticRenderFns } from "./OffersClaimedChartComponent.vue?vue&type=template&id=9b182c04"
import script from "./OffersClaimedChartComponent.vue?vue&type=script&lang=js"
export * from "./OffersClaimedChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports